import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyaları
const resources = {
  tr: {
    translation: {
      // Genel
      "welcome": "Hoş Geldiniz",
      "login": "Giriş Yap",
      "logout": "Çıkış Yap",
      "dashboard": "Dashboard",
      "settings": "Ayarlar",
      "profile": "Profil",
      "language": "Dil",
      "save": "Kaydet",
      "cancel": "İptal",
      "delete": "Sil",
      "edit": "Düzenle",
      "add": "Ekle",
      "search": "Ara",
      "loading": "Yükleniyor...",
      "error": "Hata",
      "success": "Başarılı",
      
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.companies": "Şirketler",
      "nav.settings": "Sistem Ayarları",
      "nav.monitoring": "İzleme",
      
      // Login
      "login.title": "Sistem Yönetimi",
      "login.username": "Kullanıcı Adı",
      "login.password": "Şifre",
      "login.submit": "Giriş Yap",
      "login.error": "Kullanıcı adı veya şifre hatalı",
      
      // Dashboard
      "dashboard.title": "Sistem Dashboard",
      "dashboard.totalCompanies": "Toplam Şirket",
      "dashboard.activeCompanies": "Aktif Şirketler",
      "dashboard.totalUsers": "Toplam Kullanıcı",
      "dashboard.systemStatus": "Sistem Durumu",
      
      // Companies
      "companies.title": "Şirket Yönetimi",
      "companies.add": "Yeni Şirket Ekle",
      "companies.name": "Şirket Adı",
      "companies.taxNumber": "Vergi Numarası",
      "companies.address": "Adres",
      "companies.contactPerson": "İletişim Kişisi",
      "companies.email": "E-posta",
      "companies.phone": "Telefon",
      "companies.status": "Durum",
      "companies.actions": "İşlemler",
      
      // Settings
      "settings.title": "Sistem Ayarları",
      "settings.general": "Genel Ayarlar",
      "settings.security": "Güvenlik Ayarları",
      "settings.notifications": "Bildirim Ayarları",
      "settings.language": "Dil Ayarları",
      
      // Profile
      "profile.title": "Profil",
      "profile.fullName": "Ad Soyad",
      "profile.email": "E-posta",
      "profile.role": "Rol",
      "profile.language": "Dil Seçimi",
      "profile.changePassword": "Şifre Değiştir",
      "profile.currentPassword": "Mevcut Şifre",
      "profile.newPassword": "Yeni Şifre",
      "profile.confirmPassword": "Şifre Tekrar",
      
      // Languages
      "language.tr": "Türkçe",
      "language.en": "English",
      "language.de": "Deutsch",
      "language.fr": "Français",
      "language.es": "Español",
      "language.ru": "Русский",
      "language.ar": "العربية",
      
      // Status
      "status.active": "Aktif",
      "status.inactive": "Pasif",
      "status.pending": "Beklemede",
      
      // Actions
      "action.view": "Görüntüle",
      "action.edit": "Düzenle",
      "action.delete": "Sil",
      "action.activate": "Aktifleştir",
      "action.deactivate": "Pasifleştir",
      
      // Messages
      "message.saveSuccess": "Başarıyla kaydedildi",
      "message.deleteSuccess": "Başarıyla silindi",
      "message.errorOccurred": "Bir hata oluştu",
      "message.confirmDelete": "Bu öğeyi silmek istediğinizden emin misiniz?",
      
      // Validation
      "validation.required": "Bu alan zorunludur",
      "validation.email": "Geçerli bir e-posta adresi giriniz",
      "validation.minLength": "En az {{min}} karakter olmalıdır",
      "validation.maxLength": "En fazla {{max}} karakter olmalıdır",
      
      // Time
      "time.now": "Şimdi",
      "time.today": "Bugün",
      "time.yesterday": "Dün",
      "time.thisWeek": "Bu Hafta",
      "time.thisMonth": "Bu Ay",
      "time.thisYear": "Bu Yıl"
    }
  },
  en: {
    translation: {
      // General
      "welcome": "Welcome",
      "login": "Login",
      "logout": "Logout",
      "dashboard": "Dashboard",
      "settings": "Settings",
      "profile": "Profile",
      "language": "Language",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "search": "Search",
      "loading": "Loading...",
      "error": "Error",
      "success": "Success",
      
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.companies": "Companies",
      "nav.settings": "System Settings",
      "nav.monitoring": "Monitoring",
      
      // Login
      "login.title": "System Management",
      "login.username": "Username",
      "login.password": "Password",
      "login.submit": "Login",
      "login.error": "Invalid username or password",
      
      // Dashboard
      "dashboard.title": "System Dashboard",
      "dashboard.totalCompanies": "Total Companies",
      "dashboard.activeCompanies": "Active Companies",
      "dashboard.totalUsers": "Total Users",
      "dashboard.systemStatus": "System Status",
      
      // Companies
      "companies.title": "Company Management",
      "companies.add": "Add New Company",
      "companies.name": "Company Name",
      "companies.taxNumber": "Tax Number",
      "companies.address": "Address",
      "companies.contactPerson": "Contact Person",
      "companies.email": "Email",
      "companies.phone": "Phone",
      "companies.status": "Status",
      "companies.actions": "Actions",
      
      // Settings
      "settings.title": "System Settings",
      "settings.general": "General Settings",
      "settings.security": "Security Settings",
      "settings.notifications": "Notification Settings",
      "settings.language": "Language Settings",
      
      // Profile
      "profile.title": "Profile",
      "profile.fullName": "Full Name",
      "profile.email": "Email",
      "profile.role": "Role",
      "profile.language": "Language Selection",
      "profile.changePassword": "Change Password",
      "profile.currentPassword": "Current Password",
      "profile.newPassword": "New Password",
      "profile.confirmPassword": "Confirm Password",
      
      // Languages
      "language.tr": "Türkçe",
      "language.en": "English",
      "language.de": "Deutsch",
      "language.fr": "Français",
      "language.es": "Español",
      "language.ru": "Русский",
      "language.ar": "العربية",
      
      // Status
      "status.active": "Active",
      "status.inactive": "Inactive",
      "status.pending": "Pending",
      
      // Actions
      "action.view": "View",
      "action.edit": "Edit",
      "action.delete": "Delete",
      "action.activate": "Activate",
      "action.deactivate": "Deactivate",
      
      // Messages
      "message.saveSuccess": "Saved successfully",
      "message.deleteSuccess": "Deleted successfully",
      "message.errorOccurred": "An error occurred",
      "message.confirmDelete": "Are you sure you want to delete this item?",
      
      // Validation
      "validation.required": "This field is required",
      "validation.email": "Please enter a valid email address",
      "validation.minLength": "Must be at least {{min}} characters",
      "validation.maxLength": "Must be at most {{max}} characters",
      
      // Time
      "time.now": "Now",
      "time.today": "Today",
      "time.yesterday": "Yesterday",
      "time.thisWeek": "This Week",
      "time.thisMonth": "This Month",
      "time.thisYear": "This Year"
    }
  },
  de: {
    translation: {
      // General
      "welcome": "Willkommen",
      "login": "Anmelden",
      "logout": "Abmelden",
      "dashboard": "Dashboard",
      "settings": "Einstellungen",
      "profile": "Profil",
      "language": "Sprache",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "edit": "Bearbeiten",
      "add": "Hinzufügen",
      "search": "Suchen",
      "loading": "Lädt...",
      "error": "Fehler",
      "success": "Erfolg",
      
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.companies": "Unternehmen",
      "nav.settings": "Systemeinstellungen",
      "nav.monitoring": "Überwachung",
      
      // Login
      "login.title": "Systemverwaltung",
      "login.username": "Benutzername",
      "login.password": "Passwort",
      "login.submit": "Anmelden",
      "login.error": "Ungültiger Benutzername oder Passwort",
      
      // Dashboard
      "dashboard.title": "System Dashboard",
      "dashboard.totalCompanies": "Gesamtunternehmen",
      "dashboard.activeCompanies": "Aktive Unternehmen",
      "dashboard.totalUsers": "Gesamtbenutzer",
      "dashboard.systemStatus": "Systemstatus",
      
      // Companies
      "companies.title": "Unternehmensverwaltung",
      "companies.add": "Neues Unternehmen hinzufügen",
      "companies.name": "Unternehmensname",
      "companies.taxNumber": "Steuernummer",
      "companies.address": "Adresse",
      "companies.contactPerson": "Kontaktperson",
      "companies.email": "E-Mail",
      "companies.phone": "Telefon",
      "companies.status": "Status",
      "companies.actions": "Aktionen",
      
      // Settings
      "settings.title": "Systemeinstellungen",
      "settings.general": "Allgemeine Einstellungen",
      "settings.security": "Sicherheitseinstellungen",
      "settings.notifications": "Benachrichtigungseinstellungen",
      "settings.language": "Spracheinstellungen",
      
      // Profile
      "profile.title": "Profil",
      "profile.fullName": "Vollständiger Name",
      "profile.email": "E-Mail",
      "profile.role": "Rolle",
      "profile.language": "Sprachauswahl",
      "profile.changePassword": "Passwort ändern",
      "profile.currentPassword": "Aktuelles Passwort",
      "profile.newPassword": "Neues Passwort",
      "profile.confirmPassword": "Passwort bestätigen",
      
      // Languages
      "language.tr": "Türkçe",
      "language.en": "English",
      "language.de": "Deutsch",
      "language.fr": "Français",
      "language.es": "Español",
      "language.ru": "Русский",
      "language.ar": "العربية",
      
      // Status
      "status.active": "Aktiv",
      "status.inactive": "Inaktiv",
      "status.pending": "Ausstehend",
      
      // Actions
      "action.view": "Anzeigen",
      "action.edit": "Bearbeiten",
      "action.delete": "Löschen",
      "action.activate": "Aktivieren",
      "action.deactivate": "Deaktivieren",
      
      // Messages
      "message.saveSuccess": "Erfolgreich gespeichert",
      "message.deleteSuccess": "Erfolgreich gelöscht",
      "message.errorOccurred": "Ein Fehler ist aufgetreten",
      "message.confirmDelete": "Sind Sie sicher, dass Sie dieses Element löschen möchten?",
      
      // Validation
      "validation.required": "Dieses Feld ist erforderlich",
      "validation.email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "validation.minLength": "Muss mindestens {{min}} Zeichen lang sein",
      "validation.maxLength": "Darf höchstens {{max}} Zeichen lang sein",
      
      // Time
      "time.now": "Jetzt",
      "time.today": "Heute",
      "time.yesterday": "Gestern",
      "time.thisWeek": "Diese Woche",
      "time.thisMonth": "Dieser Monat",
      "time.thisYear": "Dieses Jahr"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n; 